import React from "react";
import { motion } from "framer-motion";
import {
  BarChart3,
  Layers,
  ScrollText,
  MapPin,
  Lock,
  Megaphone,
} from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const ICONS = [BarChart3, Layers, ScrollText, MapPin, Lock, Megaphone];

const WhyUs = () => {
  const { dict } = useI18n();
  const w = dict.whyUs;

  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative py-20 md:py-28 bg-[hsl(var(--tbs-navy-950))] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none"
           style={{
             backgroundImage:
               "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)",
             backgroundSize: "22px 22px",
           }}
      />
      <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-[hsl(var(--accent))]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-[11px] font-semibold tracking-[0.18em] text-[hsl(var(--accent))] uppercase">
            {w.eyebrow}
          </div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl lg:text-5xl leading-[1.08]">
            {w.title}
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {w.items.map((it, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.45, delay: idx * 0.04 }}
                data-testid={`why-us-item-${idx}`}
                className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 hover:bg-white/[0.06] transition-colors"
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[hsl(var(--accent))] text-[hsl(var(--tbs-navy-950))]">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-display text-xl text-white">{it.title}</h3>
                <p className="mt-2 text-sm text-white/75 leading-relaxed">{it.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
